(function () {
  function findSource(scope) {
    // Das ist bei dir der echte Preis (Original unten)
    var span = scope.querySelector('span[data-product-price].product__price');
    if (!span) return null;

    // Nimm den nächstgrößeren Wrapper (damit Sale/Compare/Badge mitkommen)
    return span.closest('.price') || span.parentElement;
  }

  function stripConflictingAttrs(root) {
    // Entfernt data-product-price im DUPLICATE (damit Impulse unten wieder sauber updatet)
    root.querySelectorAll('[data-product-price]').forEach(function (el) {
      el.removeAttribute('data-product-price');
    });

    // Entfernt evtl. ProductPrice- IDs im Duplicate (sicher ist sicher)
    root.querySelectorAll('[id^="ProductPrice-"]').forEach(function (el) {
      el.removeAttribute('id');
    });
  }

  function syncAll() {
    var dups = document.querySelectorAll('[data-plisstek-price-dup]');
    if (!dups.length) return;

    dups.forEach(function (dup) {
      var scope = dup.closest('[data-section-id]') || document;

      var src = findSource(scope) || findSource(document);
      if (!src) return;

      dup.innerHTML = src.innerHTML;
      stripConflictingAttrs(dup);
    });
  }

  function schedule() {
    syncAll();
    setTimeout(syncAll, 50);
    setTimeout(syncAll, 200);
    setTimeout(syncAll, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  // Variantwechsel / Auswahl
  document.addEventListener('variant:change', schedule);
  document.addEventListener('variant:changed', schedule);
  document.addEventListener('change', schedule, true);
})();
